<template>
  <WdsRadioGroup v-model:checked="internalModelValue" :name="name">
    <WdsRadio value="sg_limited" :disabled="disabled">
      <WdsText
        :text="$t('Private Limited Company')"
        :sub-text="$t('If you have a private limited company under the Companies Act')"
      />
    </WdsRadio>
    <WdsRadio value="sg_sole_trader" :disabled="disabled">
      <WdsText :text="$t('Sole Trader')" :sub-text="$t('If you have sole proprietorship')" />
    </WdsRadio>
  </WdsRadioGroup>
</template>

<script setup>
import { computed } from 'vue'
import { WdsRadio, WdsRadioGroup, WdsText } from '@worksome/wds-components'
import { useTranslation } from '@/composables/translation'

const { $t } = useTranslation()

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])

const internalModelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})
</script>
